const PERCENT_MULTIPLIER = 100;

export function formatFloatAsPercent(value: number): string {
	return `${Math.ceil(value * PERCENT_MULTIPLIER)}%`;
}

// Math.max(...[]) returns -Infinity; treat an empty/absent array as "no value" instead.
export function safeMax(values?: number[] | null): number | undefined {
	return values?.length ? Math.max(...values) : undefined;
}
